module.exports = {
  name: '加班資料',
  schema: {
    type: 'Object',
    contents: {
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'users',
        refKeys: ['name'],
      },
      start: {
        type: 'Date',
        name: '開始時間',
        format: 'YYYY/MM/DD HH:mm:ss',
        parseFormat: 'YYYYMMDDHHmmss',
        input: 'text',
      },
      end: {
        type: 'Date',
        name: '結束時間',
        format: 'YYYY/MM/DD HH:mm:ss',
        parseFormat: 'YYYYMMDDHHmmss',
        input: 'text',
      },
      type: {
        type: 'String',
        name: '類別',
        options: ['一般', '交通'],
      },
      project: { type: 'String', name: '專案名稱' },
      work: { type: 'String', name: '內容代碼' },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'stafferRef', width: 100 },
        { key: 'type', width: 100 },
        { key: 'start', width: 200 },
        { key: 'end', width: 200 },
        { key: 'project', width: 200 },
        { key: 'work', width: 200 },
      ],
    },
    editor: {
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'stafferRef' }],
            [{ key: 'type' }],
            [{ key: 'start' }],
            [{ key: 'end' }],
            [{ key: 'project' }],
            [{ key: 'work' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/overtimeRecords.js